export enum FlowTypes {
  EMPTY = '',
  INHERITANCE = 'INHERITANCE',
  GIFTING = 'GIFTING',
  MINOR = 'MINOR',
  MULT = 'MULT',
  MULTI_INHERITANCE = 'MULTI_INHERITANCE',
  INTERNAL_TRANSFER = 'INTERNAL_TRANSFER',
  INTERNAL = 'INTERNAL', // Added for new submit metrics events
  INHERITED_IRA = 'INHERITED_IRA',
  DIVORCE = 'DIVORCE',
}

export const flowMapper = {
  '': 'empty',
  INHERITANCE: 'inheritance',
  GIFTING: 'gifting',
  MINOR: 'minor',
  INTERNAL_TRANSFER: 'internal_transfer',
  MULT: 'mult',
  MULTI_INHERITANCE: 'multi_inheritance',
  INTERNAL: 'internal',
  INHERITED_IRA: 'inherited_ira',
  DIVORCE: 'divorce',
};

export const urlMapper: { [key in FlowTypes]?: string } = {
  [FlowTypes.INHERITANCE]: 'inheritance',
  [FlowTypes.GIFTING]: 'gifting',
  [FlowTypes.MINOR]: 'minor-transfer',
  [FlowTypes.MULTI_INHERITANCE]: 'multi-inheritance',
  [FlowTypes.INTERNAL_TRANSFER]: 'internal-transfer',
  [FlowTypes.INHERITED_IRA]: 'inherited-ira',
  [FlowTypes.DIVORCE]: 'divorce',
};
